import React, { useEffect, useState } from 'react'
import {
	Body,
	ExchangeItemStyle,
	ExchangeAddItem,
	Preview,
	Title,
	Price,
	ButtonGroup,
	SwiperSlider,
	Description,
	Editor,
	ButtonDescription,
} from './style'
import { FormattedMessage } from 'react-intl'
import { ButtonFull } from 'components/Form/Button'
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom'
import { setItemExchange, removeItemExchanges } from 'components/Steps/slices'
import { useDispatch, useSelector } from 'react-redux'
import ItemAttributes from 'components/ItemAttributes'
import SelectItem from '../SelectItem'
import { setContinueUrl } from 'components/Footer/slices'
import { Icon } from '../../../../components/Icon'
import { clearIsNeedToRemoveExchangeVariant } from '../../slice'
import { formatPrice } from '../../../../utils/common'
import ReactHtmlParser from 'react-html-parser'
import { WrapperBtnText } from '../../../../components/Footer/components/FooterNav/style'
import { size } from 'components/Variable'
import { debounce } from 'lodash'
import { showPopup } from '../../../../components/Modal/slices'
import { swiperDefaultOptions } from 'configs/config'
import defaultImage from './default-image.png'

/**
 * checkStockStatus {Function}
 * @description - Generate object options with options status in stock or not in stock
 * */
const checkStockStatus = (options, lastAdd, variants, currentOptionsArr) => {
	let newObj = {}
	var optionIndex = 0
	let indexes = {}

	//find last click select options
	let filter = currentOptionsArr.filter((i) => {
		if (i[1].label === lastAdd) {
			return i
		}
	})

	const selectedIndex = filter[0] && filter[0][0]
	const selectedName = filter[0] && filter[0][1]
	const keyName = []

	//_.findIndex(options, )

	//find indexOf all keys for generate key variants
	for (let key in options) {
		if (options.hasOwnProperty(key)) {
			indexes[key] = optionIndex
		}
		optionIndex += 1
	}

	// loop options object
	for (let [key, value] of Object.entries(options)) {
		// don't iteration last selected option
		if (key !== lastAdd) {
			// generate new object option
			newObj[key] = value?.map((item) => {
				keyName[selectedIndex] = selectedName?.value
				keyName[indexes[key]] = item?.value
				//clear arr from undefined item
				let keyNameFilter = keyName.filter((i) => i?.length)
				return {
					...item,
					outOfStock:
						variants[keyNameFilter.join('-')]?.stockStatus !==
						'IN_STOCK',
				}
			})
		} else {
			//add in obj last selected option
			if (options && Object.keys(options).length === 1) {
				newObj[key] = value.map((item) => {
					return {
						...item,
						outOfStock:
							variants[item.value]?.stockStatus !== 'IN_STOCK',
					}
				})
			} else {
				newObj[key] = value
			}
		}
	}
	return newObj
}

const ExchangeItem = ({
	item = {},
	onFilledFieldAction = () => {},
	inactive = false,
	isLoading,
}) => {
	const { nextFlowStep } = useSelector((state) => state.steps)
	const { isNeedToRemoveExchangeVariant, deleteId } = useSelector(
		(state) => state.exchange
	)
	const [itemState, setItemState] = useState(item)
	let { variants, orderItemId, options = {} } = item
	let {
		name,
		imageUrl,
		price,
		productVariantExternalId,
		productExternalId,
		description,
		currency,
	} = itemState

	//is needed in order to store options before putting them in currentOptions
	let objCurrentOptions = {}
	const [currentOptions, setCurrentOptions] = useState({
		lastAdd: null,
	})
	/**
	 * getDefaultOptions {Function}
	 * @description - get default attributes options
	 * @return {Object}
	 * */
	let getDefaultOptions = () => {
		let defaults = {}
		for (let key in options) {
			if (options.hasOwnProperty(key)) {
				defaults[key] =
					options[key].length === 1
						? {
								label: options[key][0].label,
								value: options[key][0].value,
						  }
						: { label: key, value: '' }
			}
		}
		return defaults
	}
	const [isOpenDescription, setIsOpenDescription] = useState(false)
	const [attrValue, setAttrValue] = useState(getDefaultOptions())
	const [selected, setSelected] = useState(false)
	const [itemOptions, setItemOptions] = useState(options)
	const [checkLength, setCheckLength] = useState(false)
	const [keyVariant, setKeyVariant] = useState('')
	const [indexOfImages, setIndexOfImages] = useState(0)
	const [showModal, setShowModal] = useState(false)
	const [width, setWidth] = useState(window.innerWidth)
	const preselect = useSelector(
		({ root }) => root.shopProperties['widget.preselect.enabled']
	)
	const animatedId = item.orderItemId

	/**
	 * openModalAndSetIndex {Function}
	 * @description - open modal window (zoom photo) for image slider
	 * */
	const openModalAndSetIndex = (index, images, name) => {
		if (!showModal) {
			return null
		}
		dispatch(
			showPopup({
				type: 'zoom',
				index,
				images,
				name,
				animatedId,
				selected,
			})
		)
	}

	/**
	 * useEffect {Function}
	 * @description - watch for changing window innerWidth with delay (using debounce)
	 * */
	useEffect(() => {
		const handleWindowResize = debounce(() => {
			const windowWidth = window.innerWidth
			setWidth(windowWidth)
			setShowModal(width >= size.tablet)
		}, 500)

		window.addEventListener('resize', handleWindowResize)
		handleWindowResize()
		return () => window.removeEventListener('resize', handleWindowResize)
	}, [width])

	useEffect(() => {
		if (isNeedToRemoveExchangeVariant && deleteId) {
			handlerRemoveItem()
		}
	}, [isNeedToRemoveExchangeVariant, deleteId])

	useEffect(() => {
		if (isLoading === false && selected) {
			let animationElement = document.getElementById(animatedId)
			animationElement.classList.add('startMotion')
			setTimeout(() => {
				animationElement.classList.remove('startMotion')
			}, 950)
		}
	}, [isLoading])

	useEffect(() => {
		let { lastAdd, ...rest } = currentOptions
		let b = Object.values(itemOptions).length
		let singleAttributes = 0
		let a = Object.values(rest).length + singleAttributes

		for (let key in itemOptions) {
			if (itemOptions.hasOwnProperty(key)) {
				if (itemOptions[key].length === 1) {
					singleAttributes += 1
				}
			}
		}

		setCheckLength(a !== b)
		onFilledFieldAction(item.orderItemId, a === b)
	}, [itemOptions, currentOptions])

	/**
	 * useEffect {Function}
	 * @description - Generate sting product key in the array of variants
	 * */
	useEffect(() => {
		const { lastAdd, ...body } = currentOptions
		const currentOptionsArr = Object.entries(body)

		const key = currentOptionsArr.map(([key, val]) => val.value).join('-')
		if (variants && variants[key]) {
			setItemState(variants[key])
			setKeyVariant(key)
		}

		if (currentOptionsArr.length || currentOptions.lastAdd) {
			setItemOptions(
				// upd itemOptions inStock / outStock
				checkStockStatus(
					itemOptions,
					lastAdd,
					variants,
					currentOptionsArr
				)
			)
		}
	}, [currentOptions])

	/**
	 * swiperOptions {Object}
	 * @description - set options for slider product exchange
	 * */
	let swiperOptions = {
		...swiperDefaultOptions,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			renderBullet: (index, className) => `
				<div class=${className}>
					<img src=${imageUrl[index]} alt=${index}/>
				</div>
			`,
		},
	}

	const dispatch = useDispatch()
	/**
	 * handlerSelectItem {Function}
	 * @description - set New Order exchange item
	 * */
	const handlerSelectItem = () => {
		if (!selected) {
			dispatch(setContinueUrl(nextFlowStep))
			dispatch(
				setItemExchange({
					key: keyVariant,
					itemEx: {
						orderItemId,
						productVariant: {
							originalOrderItemId: orderItemId,
							product: {
								productExternalId,
							},
							productVariantExternalId,
						},
					},
				})
			)
			onFilledFieldAction(item.orderItemId, false)
		}
		setSelected(true)
	}
	/**
	 * handlerRemoveItem {Function}
	 * @description - remove item from new order list and patrial request
	 * */
	const handlerRemoveItem = () => {
		let idToDelete = deleteId ? deleteId : orderItemId
		dispatch(removeItemExchanges(idToDelete))
		setSelected(false)
		setOptionsToDefault()
		if (isNeedToRemoveExchangeVariant && deleteId) {
			dispatch(clearIsNeedToRemoveExchangeVariant())
		}
	}

	const handlerRenderSelectItem = (value, currentValue, attr) => {
		let singleLabels = {}
		if (value?.value.value !== '') {
			objCurrentOptions[value.idx] = value.value
		} else {
			for (let key in itemOptions) {
				if (itemOptions.hasOwnProperty(key)) {
					if (itemOptions[key].length === 1) {
						singleLabels[key] = true
					}
				}
			}

			if (
				!singleLabels[
					objCurrentOptions[value.idx]
						? objCurrentOptions[value.idx].label
						: ''
				]
			) {
				delete objCurrentOptions[value.idx]
			}

			if (
				!singleLabels[
					currentOptions[value.idx]
						? currentOptions[value.idx].label
						: ''
				]
			) {
				delete currentOptions[value.idx]
			}
		}

		setCurrentOptions({
			...currentOptions,
			...objCurrentOptions,
			lastAdd: value.lastAdd,
		})

		setAttrValue({ ...attrValue, [attr]: currentValue })
	}

	let isOneItem = () => {
		let isOneItem = true

		for (let key in item.options) {
			if (item.options.hasOwnProperty(key)) {
				let currentOptions = item.options[key]
				if (currentOptions.length > 1) {
					isOneItem = false
				}
			}
		}

		return isOneItem
	}

	/**
	 * setOptionsToDefault {Function}
	 * @description - set options in select item to default
	 * */
	let setOptionsToDefault = () => {
		let b = Object.values(itemOptions).length
		let labels = []
		setItemState(item)

		for (let key in currentOptions) {
			if (currentOptions.hasOwnProperty(key)) {
				labels.push(currentOptions[key]?.label)
			}
		}

		for (let i = 0; i < b; i += 1) {
			handlerRenderSelectItem({
				idx: i,
				value: { value: '', label: labels[i] },
				lastAdd: labels[i],
			})
		}

		setAttrValue(getDefaultOptions())
	}

	return (
		<ExchangeItemStyle>
			{!!imageUrl.length ? (
				<SwiperSlider>
					<ReactIdSwiperCustom
						{...swiperOptions}
						rebuildOnUpdate={true}
					>
						{imageUrl?.map((url, idx) => (
							<Preview className='swiper-slide' key={idx}>
								<img
									src={url}
									alt={idx}
									onClick={() =>
										openModalAndSetIndex(
											indexOfImages,
											imageUrl,
											name
										)
									}
								/>
							</Preview>
						))}
					</ReactIdSwiperCustom>
					<ExchangeAddItem id={animatedId} isVisible={selected}>
						<img src={imageUrl[0]} alt={name} />
					</ExchangeAddItem>
				</SwiperSlider>
			) : (
				<>
					<img className='mx-auto' src={defaultImage} />
					<ExchangeAddItem id={animatedId} isVisible={selected}>
						<img src={defaultImage} alt={name} />
					</ExchangeAddItem>
				</>
			)}

			<Body>
				<div className='flex justify-content-between align-items-end'>
					<Title>{name}</Title>
					<Price>{formatPrice(price, currency)}</Price>
				</div>
				<ItemAttributes
					className='mb-4'
					size='large'
					attributes={item.attributes}
				/>
				{Object.entries(itemOptions).map(([key, options], idx) => {
					return (
						<SelectItem
							key={key}
							item={item}
							value={attrValue[key]}
							setItemState={setItemState}
							isSearchable={false}
							onChangeAction={handlerRenderSelectItem}
							preselect={preselect}
							keyItem={key}
							options={options}
							idx={idx}
							selected={selected}
						/>
					)
				})}
				<ButtonGroup className='row'>
					<div
						className={
							selected ? 'col-12 col-md-12' : 'col-6 col-md-6'
						}
					>
						{selected ? (
							<ButtonFull
								className='mb-3 secondary remove-exchange-item-control'
								w100
								icon='trashCart'
								iconPosition='left'
								onClick={handlerRemoveItem}
								inactive={inactive}
							>
								<FormattedMessage
									id='changeProduct.btnGroup.reject'
									defaultMessage='Remove Item'
								/>
							</ButtonFull>
						) : (
							<ButtonFull
								className='mb-3 secondary dont-select-exchange-item-control'
								w100
								onClick={
									checkLength
										? () => {}
										: () => {
												if (isOneItem()) {
													setCheckLength(true)
													onFilledFieldAction(
														item.orderItemId,
														false
													)
												} else {
													setOptionsToDefault()
												}
										  }
								}
								disabled={checkLength}
							>
								<WrapperBtnText disabled={checkLength}>
									<FormattedMessage
										id='changeProduct.btnGroup.dontSelect'
										defaultMessage="Don't select"
									/>
								</WrapperBtnText>
							</ButtonFull>
						)}
					</div>
					{!!!selected && (
						<div className='col-6 col-md-6'>
							<ButtonFull
								className='mb-3 select-exchange-item-control'
								w100
								icon={selected ? `check` : `shoppingCart`}
								iconPosition='left'
								disabled={checkLength}
								selected={selected}
								inactive={selected}
								onClick={handlerSelectItem}
							>
								<WrapperBtnText
									disabled={checkLength}
									className='pl-3'
								>
									<FormattedMessage
										id='changeProduct.btnGroup.addToCard'
										defaultMessage='Select'
									/>
								</WrapperBtnText>
							</ButtonFull>
						</div>
					)}
				</ButtonGroup>
				{!!description && (
					<>
						<ButtonDescription
							isOpen={isOpenDescription}
							w100
							onClick={() =>
								setIsOpenDescription(!isOpenDescription)
							}
						>
							<Icon className='icon-left' component='arrowDown' />
							<FormattedMessage
								id='changeProduct.seeDescription'
								defaultMessage='View Full Product Description'
							/>
							<Icon
								className='icon-right'
								component='arrowDown'
							/>
						</ButtonDescription>
						<Description isOpen={isOpenDescription}>
							<Editor>{ReactHtmlParser(description)}</Editor>
						</Description>
					</>
				)}
			</Body>
		</ExchangeItemStyle>
	)
}
export default ExchangeItem
